import {
	FEE_CATEGORY,
	WORKSPACE_TYPE,
	ANALYSIS_LEVELS,
	TEMPLATES,
	HIERARCHY_LEVELS_INCLUDE,
	FREQUENCY_OPTIONS,
} from 'containers/phoenix/data/DropDownOptions';
import {
	lastDateofLastMonth,
	lastDateOfMidMonth,
	lastDateOfMidYear,
} from 'utils/dateUtil';
import { SHOW_DETAILS } from 'containers/phoenix/data/CheckBoxOptions';
import { tranformPhoenixData } from '../utils/dataUtils';
import { getXDEFlavouredDimensions } from '../data/dimensions/dimensionsParser';
import { defaultDimensions } from '../data/dimensions/dimensions';
import {
	defaultMetrics,
	defaultTSMetrics,
} from '../data/metrics/metricConfigBuilder';
import { getXDEFlavouredMetrics } from '../data/metrics/metricsParser';

const initialState = {
	token: '',
	clients: [],
	accounts: [],
	hierarchies: [],
	benchmarks: [],
	clientDimensions: [],
	fees: [], // Hardcoded
	request: {}, // metrics
	showLoader: false,
	inputData: {
		client: null,
		workspaceType: WORKSPACE_TYPE[0],
		analysisLevel: ANALYSIS_LEVELS[0],
		template: 'Custom',
		accountId: [],
		hierarchy: null,
		hierarchyLevel: null,
		referancedate: { text: lastDateofLastMonth() },
		startdate: { text: lastDateOfMidYear() },
		enddate: { text: lastDateofLastMonth() },
		fee: FEE_CATEGORY[0],
		benchmark: null,
		cellNumber: null,
		sheetName: null,
		inputEndRange: null,
		outputEndRange: null,
		frequency: FREQUENCY_OPTIONS[0],
	},
	displaySetting: {
		cellId: null,
		sheetName: null,
		displaySetting: SHOW_DETAILS,
	},
	dimensions: {
		selectedDimensions: defaultDimensions,
		xdeDimensions: getXDEFlavouredDimensions(defaultDimensions)
			.xdeFlavouredDimensions,
		xdeDimensionOrder: getXDEFlavouredDimensions(defaultDimensions)
			.dimensionOrder,
	},
	metrics: {
		selectedMetrics: defaultMetrics,
		xdeMetrics: getXDEFlavouredMetrics(defaultMetrics).xdeFormattedMetrics,
		xdeMetricsOrder: getXDEFlavouredMetrics(defaultMetrics).xdeMetricsOrder,
	}, // metrics
	selectedDataset: null,
};

export default function phoenixReducer(state = initialState, action = {}) {
	switch (action.type) {
		case 'CLIENTS_DATA': {
			const clientOptions = tranformPhoenixData(
				action.payload,
				'SponsorCode',
				'ClientName',
			);
			return {
				...state,
				inputData: {
					...state.inputData,
					client: state.inputData.client
						? state.inputData.client
						: clientOptions[0],
				},
				clients: clientOptions,
			};
		}
		case 'ACCOUNTS_DATA': {
			const accountOptions = tranformPhoenixData(
				action.payload,
				'accountBusinessID',
				'accountLongName',
				true,
			);
			return {
				...state,
				inputData: {
					...state.inputData,
					accountId:
						state?.selectedDataset?.editClicked &&
						state.inputData?.accountId.length > 0
							? state.inputData.accountId
							: [accountOptions[0]],
				},
				accounts: accountOptions,
			};
		}
		case 'HIERARCHY_DATA': {
			return {
				...state,
				hierarchies: tranformPhoenixData(
					action.payload,
					'level1GroupID',
					'level1GroupName',
				),
			};
		}
		case 'BENCHMARKS_DATA': {
			const benchmarkOpt = tranformPhoenixData(
				action.payload,
				'benchmarkBusinessID',
				'benchmarkUsage',
			);
			return {
				...state,
				inputData: {
					...state.inputData,
					benchmark: state.inputData.benchmark
						? state.inputData.benchmark
						: benchmarkOpt[0],
				},
				benchmarks: benchmarkOpt,
			};
		}
		case 'CLIENT_DIMENSIONS_DATA':
			return {
				...state,
				benchmarks: tranformPhoenixData(
					action.payload,
					'SponsorCode',
					'DimensionDisplayName',
				),
			};
		case 'UPDATE_CLIENT':
		case 'UPDATE_TEMPLATE':
		case 'UPDATE_HIERARCHY':
		case 'UPDATE_HIERARCHYLEVEL':
		case 'UPDATE_REFERANCEDATE':
		case 'UPDATE_BENCHMARK':
		case 'UPDATE_CELLNUMBER':
		case 'UPDATE_SHEETNAME':
		case 'UPDATE_FEE':
		case 'UPDATE_STARTDATE':
		case 'UPDATE_ENDDATE':
		case 'UPDATE_INPUT_RANGE':
		case 'UPDATE_OUTPUT_RANGE':
		case 'UPDATE_FREQUENCY':
			return {
				...state,
				inputData: {
					...state.inputData,
					[action.key]: action.payload,
				},
			};
		case 'UPDATE_ANALYSISLEVEL':
			return {
				...state,
				inputData: {
					...state.inputData,
					accountId:
						action.payload.key === 'Account' ||
						action.payload.key === 'CustomGroup'
							? [state.accounts[0]]
							: [],
					benchmark: state.benchmarks[0],
					hierarchy:
						action.payload.key === 'Hierarchy'
							? state.hierarchies[0]
							: null,
					hierarchyLevel:
						action.payload.key === 'Hierarchy'
							? HIERARCHY_LEVELS_INCLUDE[0]
							: null,
					[action.key]: action.payload,
				},
			};
		case 'UPDATE_WORKSPACETYPE': {
			let defaultOption = {};
			if (action.payload.key === 'attribution') {
				defaultOption = {
					...state.inputData,
					hierarchy: null,
					hierarchyLevel: null,
					analysisLevel: null,
					template: 'Custom',
					accountId: [state.accounts[0]],
				};
			} else {
				defaultOption = {
					...state.inputData,
					hierarchy: state.hierarchies[0],
					hierarchyLevel: HIERARCHY_LEVELS_INCLUDE[0],
					analysisLevel: ANALYSIS_LEVELS[0],
					template: 'Custom',
					accountId: [state.accounts[0]],
				};
			}
			return {
				...state,
				inputData: {
					...defaultOption,
					[action.key]: action.payload,
				},
			};
		}
		case 'UPDATE_ACCOUNTID': {
			let selectedAccounts;
			// NOTE: for multiselect selected wont be undifined.
			if (action.payload.selected !== undefined) {
				selectedAccounts = action.payload.selected
					? [...state.inputData.accountId, action.payload]
					: state.inputData.accountId.filter(
							acc => acc.key !== action.payload.key,
					  );
			} else {
				selectedAccounts = [action.payload];
			}
			return {
				...state,
				benchmarks: [],
				inputData: {
					...state.inputData,
					// benchmark: null,
					[action.key]: selectedAccounts,
				},
			};
		}
		case 'UPDATE_CELL_SHEET':
			return {
				...state,
				inputData: {
					...state.inputData,
					cellNumber: action.payload.cellId,
					sheetName: action.payload.sheetName,
				},
			};
		case 'METRICS_DATA':
			return {
				...state,
				metrics: action.payload,
			};

		case 'SELECT_DIMENSION':
			const updatedSelectedDimensions = action.payload.checked
				? [...state.dimensions.selectedDimensions, action.payload.data]
				: state.dimensions.selectedDimensions.filter(
						dimension => dimension !== action.payload.data,
				  );

			const { dimensionOrder } = getXDEFlavouredDimensions(
				updatedSelectedDimensions
			);

			const dimValues = action.payload.data.split('|');

			return {
				...state,

				dimensions: {
					...state.dimensions,
					xdeDimensions : state.dimensions.xdeDimensions.map(
						dim => dim.colId === dimValues[0] ? 
							{
									...dim,
								dropDowns : dim.dropDowns.map(
									dd => dd.colId === action.payload.data ? 
								{
													...dd,
											selected: action.payload.checked,
										} : dd)
							}	: dim),					
					selectedDimensions: updatedSelectedDimensions,
					xdeDimensionOrder: dimensionOrder,
				},
			};

		case 'UPDATE_XDE_DIMENSIONS':
			return {
				...state,
				dimensions: {
					...state.dimensions,
					xdeDimensions: state.dimensions.xdeDimensions.map(
						dim => dim.colId === action.payload.colId[0] ?
							{
								...dim,
								expand : !dim.expand
							} : dim
					)
				},
			};

		case 'UPDATE_XDE_DIMENSIONS_ORDER':
			return {
				...state,
				dimensions: {
					...state.dimensions,
					xdeDimensionOrder: action.payload.data,
				},
			};

		case 'SELECT_METRIC':
			const updatedSelectedMetrics = action.payload.checked
				? [...state.metrics.selectedMetrics, action.payload.data]
				: state.metrics.selectedMetrics.filter(
						metric =>
							metric.metric + metric.timeperiod !==
							action.payload.data.metric +
								action.payload.data.timeperiod,
				  );

			const metricsOrder = getXDEFlavouredMetrics(
				updatedSelectedMetrics,
				state?.selectedDataset?.serviceData?.serviceId,
			).xdeMetricsOrder;

			return {
				...state,
				metrics: {
					...state.metrics,
					selectedMetrics: updatedSelectedMetrics,
					xdeMetricsOrder: metricsOrder,
					xdeMetrics: state.metrics.xdeMetrics.map(
						metric => metric.colId === action.payload.data.metric ?
							{
									...metric,
								selected : metric.dropDowns.length === 0 ? action.payload.checked : metric.selected,
								dropDowns: metric.dropDowns.map(
									dd => dd.colId === (action.payload.data.metric + '|' + action.payload.data.timeperiod) ?
										{
													...dd,
											selected: action.payload.checked,
										} : dd)
							} : metric)
				}

			};


		case 'UPDATE_XDE_METRICS':
			return {
				...state,
				metrics: {
					...state.metrics,
					xdeMetrics: state.metrics.xdeMetrics.map(
						metric => metric.colId === action.payload.colId[0] ?
							{
									...metric,
								expand : !metric.expand
							} : metric
					)
				},
			};

		case 'UPDATE_METRICS_ON_SERVICE_SELECTION': {
			const { serviceId } = action?.payload || {};
			const {
				xdeFormattedMetrics,
				xdeMetricsOrder,
			} = getXDEFlavouredMetrics(
				serviceId === 'PhoenixTimeSeries'
					? defaultTSMetrics
					: defaultMetrics,
				serviceId,
			);
			// serviceId === 'PhoenixTimeSeries'
			return {
				...state,
				metrics: {
					...state.metrics,
					selectedMetrics:
						serviceId === 'PhoenixTimeSeries'
							? defaultTSMetrics
							: defaultMetrics,
					xdeMetricsOrder,
					xdeMetrics: xdeFormattedMetrics,
				}
			};
		}

		case 'UPDATE_XDE_METRICS_ORDER':
			return {
				...state,
				metrics: {
					...state.metrics,
					xdeMetricsOrder: [...action.payload.data],
				},
			};

		case 'RESET_ALL_DATA':
			return {
				...initialState,
				token: state.token,
			};
		case 'SHOW_LOADER':
			return {
				...state,
				showLoader: action.payload,
			};
		case 'UPDATE_TOKEN':
			return {
				...state,
				token: action.payload,
			};
		case 'UPDATE_DISPLAY_CELL_SHEET':
			return {
				...state,
				displaySetting: {
					...state.displaySetting,
					cellId: action.payload.cellId,
					sheetName: action.payload.sheetName,
				},
			};
		case 'UPDATE_DISPLAY_SETTINGS':
			return {
				...state,
				displaySetting: {
					...state.displaySetting,
					displaySetting: state.displaySetting.displaySetting.map(
						item =>
							item.id === action.value.id
								? {
										...item,
										value:
											action.value.value !== undefined &&
											action.value.value !== null
												? action.value.value
												: item.value,
										error: action.value.error
											? action.value.error
											: false,
										selected:
											action.selected !== undefined
												? action.selected
												: item.selected,
								  }
								: item,
					),
				},
			};
		case 'SELECTED_PHOENIX_DATASET':
			if (action.payload === null) {
				return state;
			}
			const inputData = {
				...action.payload.inputNodes.inputData,
				referancedate: action.payload.inputNodes.inputData.referancedate ?
					{text : new Date(action.payload.inputNodes.inputData.referancedate.text)} : { text: lastDateofLastMonth() },
				startdate: action.payload.inputNodes.inputData.startdate ?
					{text : new Date(action.payload.inputNodes.inputData.startdate.text)} : { text: lastDateOfMidYear() },
				enddate: action.payload.inputNodes.inputData.enddate ?
					{text : new Date(action.payload.inputNodes.inputData.enddate.text)} : { text: lastDateofLastMonth() },
			};
			return {
				...state,
				inputData,
				displaySetting: action.payload.displaySetting,
				dimensions: action.payload.dimensions,
				metrics: action.payload.metrics,
				selectedDataset: {
					reportId: action.payload.reportId,
					reportName: action.payload.reportName,
					reportType:	action.payload.reportType,
					datasetRange: action.payload.datasetRange,
					duplicateClicked: action.payload.duplicateClicked,
					editClicked: action.payload.editClicked,
					lastRefreshTime: action.payload.lastRefreshTime,
					serviceData: action.payload.serviceData,
					service: action.payload.service,
				}
			};

		case 'DUPLICATE_DATASET':
			return {
				...state,
				inputData: {
					...state.inputData,
					cellNumber: '',
					sheetName: '',
					inputEndRange: null,
					outputEndRange: null,
				},
				displaySetting: {
					...state.displaySetting,
					cellId: '',
					sheetName: '',
				},
			};
		default:
			return state;
	}
}
